export default __webpack_public_path__ + "static/media/PhysicalDescriptions_09.326db01b.png";